// import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

// Export a function instead of running immediately
export default function mountReactApp() {
  const container = document.getElementById('root')
  if (container) {
    createRoot(container).render(<App />)
  }
}